module.exports = __webpack_public_path__ + "img/hover_icon_student_online_registry.c2306c4a.svg";